export default (theme) => ({
  root: {
    height: '100%',
  },
  dropdownButton: {
    marginRight: -theme.spacing.unit * 2,
  },
  chartWrapper: {
    height: '400px',
    position: 'relative',
  },
  portletFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  labelCharts: {
    position: 'relative',
    display: 'flex',
    bottom: '15.5%',
    left: '14%',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});
